// Multiplayer-wheel special-item icons, eager-globbed for their bundled
// URLs. Same set the deploy strip + loadout strip resolve via the
// `item:{ID}` aliases; we warm them into the browser HTTP cache shortly
// after boot so those Pixi strips don't flash their 3-letter fallback
// (SHA / SHI / COI) while the textures download on first entry to the
// wheel game (producer 2026-06-10).
const ITEM_ICON_MODULES = import.meta.glob<{ default: string }>(
  './assets/item/*.png',
  { eager: true },
);

/**
 * Fire-and-forget cache warm for the wheel item icons. A plain
 * {@code new Image()} per URL primes the browser's HTTP cache (the slow,
 * network part); the engine's AssetLoader / Pixi {@code Assets.load} then
 * decodes from cache instead of fetching cold. Deferred to idle so it
 * never competes with the critical boot fetches. Safe to call more than
 * once — repeat loads are cache hits.
 */
export function preloadWheelItemIcons(): void {
  const warm = (): void => {
    for (const mod of Object.values(ITEM_ICON_MODULES)) {
      const img = new Image();
      img.src = mod.default;
    }
  };
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(warm);
  } else {
    // Safari fallback — defer past the critical boot fetches.
    setTimeout(warm, 1500);
  }
}
